// src/components/WhoWeAre.js
import React from 'react';
import { motion } from 'framer-motion';

const WhoWeAre = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.sectionTitle}>¿Quiénes somos?</h2>
        <div style={styles.content}>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: 'spring', stiffness: 200, damping: 10 }}
            style={styles.icon}
          >
            <span style={{ fontSize: '3rem', color: '#4361ee' }}>🔍</span>
          </motion.div>
          <div style={styles.text}>
            <p style={styles.paragraph}>
              Somos un equipo que se encarga de buscar los productos que tú deseas.
            </p>
            <p style={styles.paragraph}>
              Si no sabes manejar las redes o no tienes tiempo para buscar un producto 
              al mejor precio posible, <strong>nosotros lo haremos por ti</strong>.
            </p>
            <p style={{ ...styles.paragraph, marginTop: '1.5rem', fontStyle: 'italic', color: '#7209b7' }}>
              De manera ética, profesional y comprometida.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '5rem 1rem',
    backgroundColor: '#ffffff',
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '2.2rem',
    color: '#212529',
    marginBottom: '3rem',
    fontWeight: '700',
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '2rem',
    flexWrap: 'wrap',
  },
  icon: {
    flexShrink: 0,
    fontSize: '2.5rem',
  },
  text: {
    flex: 1,
    minWidth: '250px',
  },
  paragraph: {
    fontSize: '1.1rem',
    color: '#495057',
    lineHeight: 1.8,
    marginBottom: '1rem',
  }
};

export default WhoWeAre;